import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=1150573e&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=1150573e&prod&lang=css"
import style1 from "./Detalhes.vue?vue&type=style&index=1&id=1150573e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1150573e",
  null
  
)

export default component.exports